import React, { memo } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import _isEqual from 'lodash/isEqual';

import StatusBadge from 'components/StatusBadge';

import { transferDetails as TEXT } from 'locales/en/transfer';
import { DAY_MONTH_YEAR } from 'utils/dateFormat';

const Summary = ({ transfer }) => {
  const { amountToDisplay, status } = transfer;

  return (
    <div className="card mb-8 p-0">
      <div className="p-6 lg:p-12">
        <p className="text-javelin-gray-light text-xs mb-3">{TEXT.net}</p>
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <span className="font-bold text-3xl">{amountToDisplay}</span>
            <StatusBadge status={status} />
          </div>
        </div>
        <p className="text-javelin-gray-light text-xs mt-3">
          {TEXT.expectedArrival}{' '}
          <b>{format(new Date(transfer.created_at), DAY_MONTH_YEAR)}</b>
        </p>
      </div>
    </div>
  );
};

Summary.propTypes = {
  transfer: PropTypes.shape({}),
};
Summary.defaultProps = {
  transfer: {},
};

const areEqual = (prevProps, nextProps) => {
  return _isEqual(prevProps.transfer, nextProps.transfer);
};

export default memo(Summary, areEqual);
